import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../../../utils/date-utils';

@Pipe({
  name: 'currentFormattedDate'
})
export class CurrentFormattedDatePipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) return '-';
    return DateUtils.formatUnixToCurrentDate((new Date(value).getTime() ?? 0) / 1000);
  }
}
